// extracted by mini-css-extract-plugin
export var grid = "styles-module--grid--ROybH";
export var tagline = "styles-module--tagline--mxmjs";
export var title = "styles-module--title--t03kN";
export var content = "styles-module--content--4DF5n";
export var links = "styles-module--links--lZKez";
export var cta = "styles-module--cta--DH7xh";
export var backAndForthRight = "styles-module--backAndForthRight--G9-21";
export var wobbleRightAndLeft = "styles-module--wobbleRightAndLeft--b6o1j";
export var animateBg = "styles-module--animateBg--jCiPb";